import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
  `}
`;

export const ComponentWrapper = styled(Wrapper)`
  margin: 48px 0;
`;

export const HeadWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const Image = styled.img`
  width: 220px;
  user-select: none;
`;

export const IconCircle = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.v2.colors.brand.primaryUltraLight};
    border-radius: 50%;
    height: 32px;
    width: 32px;
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.sm2};
    margin: 8px 0;
  `}
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 40px 0;
`;

export const HelpLabel = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    margin: 0;
  `}
`;

export const ButtonsWrapper = styled.div`
  align-self: end;
  display: flex;
  justify-content: space-between;
  position: relative;
  margin-top: 40px;
  width: 100%;
`;

export const ButtonContainer = styled.div``;
